export default "__VITE_ASSET__CNBWQdw4__"